import {Component, OnInit} from '@angular/core';
import {InfoPageComponent} from '../../shared/components/info-page/info-page.component';
import {ActivatedRoute} from '@angular/router';
import {LangService} from '../../core/services/lang.service';
import {Nl2brPipe} from '../../shared/pipes/nl2br.pipe';
import {HowWorksService} from '../../core/api/how-works.service';
import {getHowWorks, HowWork, HowWorks} from '../../shared/models/how-works.model';
import {SafeResourceUrl} from '@angular/platform-browser';
import {VideoEmbedService} from '../../core/services/video-embed.service';

@Component({
  selector: 'app-how-it-works-detail',
  templateUrl: './how-it-works-detail.component.html',
  imports: [InfoPageComponent, Nl2brPipe]
})
export class HowItWorksDetailComponent implements OnInit {
  videoSrc: SafeResourceUrl | null = null;
  imageSrc = '';
  imageAlt?: string;
  subtitle?: string;
  text?: string;
  howWork?: HowWork;

  constructor(private route: ActivatedRoute,
              private howWorksService: HowWorksService,
              private langService: LangService,
              private videoEmbed: VideoEmbedService
  ) {
  }

  ngOnInit(): void {
    const howWorksId = this.route.snapshot.paramMap.get('id');
    if (howWorksId) {
      this.loadHowWorks(parseInt(howWorksId));
    }
  }

  private loadHowWorks(id: number) {
    this.howWorksService.getHowWorks().subscribe({
      next: (howWorks: HowWorks) => {
        const howWorksByLang = getHowWorks(howWorks);
        this.howWork = howWorksByLang.find(howWork => howWork.id === id);
        console.log(this.howWork);
        if (this.howWork) {
          this.videoSrc = this.videoEmbed.toYouTubeEmbedSrc(this.howWork.video);
          this.imageSrc = this.howWork.picture || '';
          this.imageAlt = this.howWork.title;
          this.subtitle = this.howWork.title;
          this.text = this.howWork.text;
        }
      },
      error: (error) => {
        console.error('Error al obtener como funciona:', error);
      }
    });
  }

}
